import { Grid, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { isValid } from "date-fns";
import { Field } from "react-final-form";

export type TemplateItem = {
  key: string;
  key_type: string;
  mandatory: boolean;
  display_value: string;
};

type UserAgreementAdditionalFieldsProps = {
  items: TemplateItem[];
};

export const UserAgreementAdditionalFields = ({
  items,
}: UserAgreementAdditionalFieldsProps) => {
  if (!items || items.length === 0) return null;

  const required = (value: any, templateItem: TemplateItem) =>
    value === undefined ||
    value === null ||
    value === "" ||
    (templateItem.key_type === "date" &&
      value instanceof Date &&
      !isValid(value))
      ? "Required"
      : undefined;

  return (
    <>
      {items.map((item, index) => {
        const baseField = `additionalFields[${index}]`;

        return (
          <Grid item xs={12} key={item.key} mt={2}>
            {/* Hidden metadata fields */}
            <Field name={`${baseField}.key`} initialValue={item.key}>
              {() => null}
            </Field>
            <Field name={`${baseField}.key_type`} initialValue={item.key_type}>
              {() => null}
            </Field>

            {(() => {
              switch (item.key_type) {
                case "text":
                  return (
                    <Field
                      name={`${baseField}.value`}
                      required={item.mandatory}
                      validate={(value) =>
                        item.mandatory ? required(value, item) : undefined
                      }
                    >
                      {({ input, meta }) => (
                        <TextField
                          {...input}
                          variant="outlined"
                          fullWidth
                          label={item.display_value}
                          required={item.mandatory}
                          error={
                            (meta.touched || meta.submitFailed) && meta.error
                          }
                          helperText={
                            (meta.touched || meta.submitFailed) && meta.error
                          }
                        />
                      )}
                    </Field>
                  );

                case "date":
                  return (
                    <Field
                      name={`${baseField}.value`}
                      required={item.mandatory}
                      validate={(value) =>
                        item.mandatory ? required(value, item) : undefined
                      }
                    >
                      {({ input, meta }) => (
                        <DatePicker
                          label={item.display_value}
                          format="MM/dd/yyyy"
                          {...input}
                          value={input.value === "" ? null : input.value}
                          slotProps={{
                            actionBar: {
                              actions: ["clear", "cancel"],
                            },
                            textField: {
                              variant: "standard",
                              error:
                                (meta.touched || meta.submitFailed) &&
                                meta.error,
                              helperText:
                                (meta.touched || meta.submitFailed) &&
                                meta.error,
                            },
                          }}
                        />
                      )}
                    </Field>
                  );

                case "number":
                  return (
                    <Field
                      name={`${baseField}.value`}
                      type="number"
                      required={item.mandatory}
                      validate={(value) =>
                        item.mandatory ? required(value, item) : undefined
                      }
                    >
                      {({ input, meta }) => (
                        <TextField
                          {...input}
                          variant="standard"
                          type="number"
                          fullWidth
                          label={item.display_value}
                          InputLabelProps={{ required: item.mandatory }}
                          error={
                            (meta.touched || meta.submitFailed) && meta.error
                          }
                          helperText={
                            (meta.touched || meta.submitFailed) && meta.error
                          }
                        />
                      )}
                    </Field>
                  );

                default:
                  return null;
              }
            })()}
          </Grid>
        );
      })}
    </>
  );
};
